<template>
  <div class="date-select">
    <div class="d-inline-block mr-12px mr-5px-m-dialog xxs-mr-0 xxs-input-birthday">
      <el-select ref="yearSelect" v-model="year" @change="change" placeholder="" class="s-year mr-5px mr-0-m-dialog mr-0" :disabled="disabled">
        <el-option v-for="y in years" :key="y" :value="y" :label="y"></el-option>
      </el-select>
      年
    </div>
    <div class="d-inline-block mr-12px mr-5px-m-dialog xxs-mr-0 xxs-input-birthday">
      <el-select ref="monthSelect" v-model="month" @change="change" placeholder="" class="s-month mr-5px mr-0-m-dialog mr-0" :disabled="disabled">
        <el-option v-for="m in months" :key="m" :value="m" :label="m"></el-option>
      </el-select>
      月
    </div>
    <div class="d-inline-block xxs-input-birthday">
      <el-select ref="daySelect" v-model="day" @change="change" placeholder="" class="s-day mr-5px mr-0-m-dialog mr-0" :disabled="disabled">
        <el-option v-for="d in days" :key="d" :value="d" :label="d"></el-option>
      </el-select>
      日
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { isIE } from '@/common/useragent'
  const NUM_PAST_YEAR = process.env.VUE_APP_NUM_PAST_YEAR

  export default {
    name: 'DateSelect',
    props: ['value', 'disabled', 'defaultYear', 'defaultMonth', 'defaultDay'],
    data () {
      const years = []
      const nowYear = new Date().getFullYear()
      for (let i = NUM_PAST_YEAR; i >= 0; i--) {
        years.push((nowYear - i).toString())
      }

      return {
        day: null,
        month: null,
        year: null,
        days: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10',
          '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21',
          '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
        months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        years: years
      }
    },
    methods: {
      initValue: function () {
        if (!this.value) {
          this.day = this.defaultDay ?? null
          this.month = this.defaultMonth ?? null
          this.year = this.defaultYear ?? null
          return
        }

        const dateReg = /^(?:\w+)-(?:\w+)-(?:\w+)$/
        if (dateReg.test(this.value)) {
          const date = this.value
          this.year = date.split('-')[0] !== 'null' ? date.split('-')[0] : null
          this.month = date.split('-')[1] !== 'null' ? date.split('-')[1] : null
          this.day = date.split('-')[2] !== 'null' ? date.split('-')[2] : null
          return
        }

        if (moment(this.value).isValid()) {
          const date = moment(this.value)
          this.year = date.format('YYYY')
          this.month = date.format('MM')
          this.day = date.format('DD')
        }
      },
      change: function () {
        const date = `${this.year}-${this.month}-${this.day}`
        this.$emit('input', date)
        this.$emit('change', date)
      }
    },
    watch: {
      value () {
        this.initValue()
      }
    },
    created () {
      this.initValue()
    },
    mounted () {
      if (isIE()) {
        // IEでel-selectのプルダウンにフォーカスするとカーソルが表示される問題を修正
        const self = this
        this.$el.querySelectorAll('input[type="text"]').forEach(el => {
            const $input = self._$(el)
            $input.css('pointer-events', 'none')
            $input.on('focus', event => event.currentTarget.blur())
        })
      }
    }
  }
</script>

<style scoped>
  .s-year {
    width: 82px !important;
  }
  .s-month, .s-day {
    width: 65px !important;
  }
  .mr-5px {
    margin-right: 5px;
  }
  .mr-12px {
    margin-right: 12px;
  }
  @media screen and (max-width: 320px) {
    .xxs-input-birthday .s-year {
      width: 74px !important;
    }
    .xxs-input-birthday .s-month, .xxs-input-birthday .s-day {
      width: 58px !important;
    }
  }
</style>
